export default "__VITE_ASSET__B4A_wrme__"